<template>
  <MPopover
    v-if="user"
    :ref="`popover-${guid}`"
    :destroy-tooltip-on-hide="false"
    trigger="click"
    placement="bottomRight"
    overlay-class-name="picker-overlay user-dropdown-popover"
    @show="handleShow"
    @hide="handleHide"
  >
    <a slot="trigger" href="javascript:;">
      <FlotoUserAvatar
        size="small"
        class="rounded-full cursor-pointer"
        :avatar="user.avatar"
      />
    </a>
    <MRow :gutter="0">
      <MCol class="w-56 items-center p-1">
        <MRow class="mx-4">
          <MCol class="user-info">
            <FlotoUserAvatar
              :size="35"
              class="rounded-full cursor-pointer"
              :avatar="user.avatar"
            />
            <div class="text-ellipsis flex flex-col">
              <span class="text-ellipsis user-name">
                {{ user.name }}
              </span>
              <span class="text-ellipsis user-email text-xs">
                <MTooltip placement="topLeft">
                  <template v-slot:trigger>
                    {{ user.email || user.userLogOnName }}
                  </template>
                  {{ user.email || user.userLogOnName }}
                </MTooltip>
              </span>
            </div>
          </MCol>
        </MRow>
        <MDivider class="my-2" />
        <UserProfile
          v-if="!isCxoTechnician()"
          :tabindex="1"
          class="mb-1"
          @trigger="hide"
        >
          <template v-slot:trigger="{ open }">
            <div ref="editProfileRef" class="user-dropdown-action-item">
              <FlotoAnchorLink @click="open">
                <MIcon name="user" />
                {{ $t('my_profile') }}
              </FlotoAnchorLink>
            </div>
          </template>
        </UserProfile>
        <div
          v-if="!isPortalLogin && user.superAdminRole"
          class="user-dropdown-action-item"
        >
          <FlotoLink :to="$modules.getModuleRoute('product-setup')">
            <div @click="hide">
              <MIcon name="book-open" />
              {{ $tc('product_guide') }}
            </div>
          </FlotoLink>
        </div>
        <MDivider class="my-2" />
        <div
          v-if="user.userType === 'technician' && !mspPortal"
          class="user-dropdown-action-item"
        >
          <FlotoAnchorLink @click="handlePortalChange">
            <MIcon
              :name="isInsidePortal ? 'technician-portal' : 'support-portal'"
              size="lg"
            />
            {{ $t('view') }}
            {{ isInsidePortal ? technicianPortalTitle : customerPortalTitle }}
          </FlotoAnchorLink>
        </div>
        <MDivider class="my-2" />
        <div class="">
          <MRadioGroup
            id="modeRadioGroup"
            v-model="mode"
            as-button
            :options="themeCodeOptions"
          >
            <template v-slot:option="{ option }">
              <div style="column-gap: 4px" class="flex items-center">
                <MIcon
                  size="lg"
                  :name="
                    option.value === 'light_theme' ? 'light-mode' : 'dark-mode'
                  "
                />
                {{ option.text }}
              </div>
            </template>
          </MRadioGroup>
        </div>
        <MDivider class="my-2" />
        <div class="user-dropdown-action-item sign-out">
          <FlotoAnchorLink @click="performLogout">
            <MIcon name="sign-out-alt" />
            {{ $t('logout') }}
          </FlotoAnchorLink>
        </div>
        <!-- <MRow ref="editProfileRef" class="mt-4 justify-around" :gutter="0">
          <MButton
            id="signout-btn"
            variant="error"
            class="mb-1"
            @click="performLogout"
          >
            {{ $t('logout') }}
          </MButton>
        </MRow> -->
        <!-- <MRow v-if="user.userType === 'technician' && !mspPortal" class="mt-4">
          <MCol class="text-center">
            <FlotoAnchorLink @click="handlePortalChange">
              <div class="font-semibold">
                {{ $t('view') }}
                {{
                  isInsidePortal ? technicianPortalTitle : customerPortalTitle
                }}
              </div>
            </FlotoAnchorLink>
          </MCol>
        </MRow> -->
        <!-- <MRow class="mt-4">
          <MCol
            v-if="!isPortalLogin && user.superAdminRole"
            class="text-center"
          >
            <FlotoLink :to="$modules.getModuleRoute('product-setup')">
              <div class="font-semibold" @click="hide">
                {{ $tc('product_guide') }}
              </div>
            </FlotoLink>
          </MCol>
        </MRow> -->
      </MCol>
    </MRow>
  </MPopover>
</template>

<script>
import Bus from '@utils/emitter'
import { isCxoTechnician } from '@utils/auth'
import { authMethods, authComputed } from '@state/modules/auth/'
import { MspConfigComputed } from '@state/modules/msp-config/helpers'
import { LicenseComputed } from '@state/modules/license'
import UserProfile from './user-profile'
import { generateId } from '@utils/id'
import {
  PreferenceComputed,
  PreferenceMethods,
} from '@state/modules/preference'
export default {
  name: 'UserDropdown',
  components: { UserProfile },
  inject: {
    popupContext: {
      default: () => ({
        popupManagerData: () => [],
      }),
    },
  },
  props: {
    portalMode: { type: Boolean, default: false },
    customerPortalTitle: { type: String, default: 'support_portal' },
    technicianPortalTitle: { type: String, default: 'technician_portal' },
  },
  data() {
    this.themeCodeOptions = [
      { text: `${this.$tc('light')}`, value: 'light_theme' },
      { text: `${this.$tc('dark')}`, value: 'dark_theme' },
    ]
    this.guid = generateId()
    this.isCxoTechnician = isCxoTechnician
    return {}
  },
  computed: {
    ...authComputed,
    ...MspConfigComputed,
    ...LicenseComputed,
    ...PreferenceComputed,
    mode: {
      get() {
        return this.theme
      },
      set(value) {
        this.updatePreference({ theme: value })
      },
    },
    isInsidePortal() {
      return this.isPortalLogin
      // return this.$route.path.indexOf('support-portal') >= 0
    },
  },
  methods: {
    ...authMethods,
    ...PreferenceMethods,
    handleHide() {
      if (this.$refs[`popover-${this.guid}`]) {
        this.$refs[`popover-${this.guid}`].hide()
      }
      const popovefRef = `popover-${this.guid}`
      if (this.popupContext && this.popupContext.popupManagerData.length) {
        const index = this.popupContext.popupManagerData.findIndex(
          (item) => Object.keys(item)[0] === popovefRef
        )

        if (index !== -1) {
          // Use splice to remove the element at the found index
          this.popupContext.popupManagerData.splice(index, 1)
        }
      }
    },

    handleShow() {
      setTimeout(() => {
        const keyExists = () => {
          const popupManagerData = this.popupContext.popupManagerData || []
          return popupManagerData.some((item) =>
            item.hasOwnProperty(`popover-${this.guid}`)
          )
        }

        if (
          this.popupContext &&
          this.popupContext.popupManagerData &&
          !keyExists()
        ) {
          const dynamicKey = `popover-${this.guid}`

          const callableObject = function () {
            this.handleHide()
          }.bind(this)

          callableObject.refData = this.$refs.editProfileRef

          this.popupContext.popupManagerData.push({
            [dynamicKey]: callableObject,
          })
        }
      }, 200)
    },
    hide() {
      this.handleHide()
    },
    performLogout() {
      const currentUser = this.user
      this.logout()
      Bus.$emit('auth:logout', currentUser)
      if (this.$route.name !== 'support-portal') {
        this.$modules.replace('support-portal')
      }
    },
    handlePortalChange() {
      this.$router.push(
        this.$modules.getModuleRoute(
          this.isInsidePortal ? 'dashboard' : 'support-portal'
        )
      )
    },
  },
}
</script>

<style lang="less">
.headerUserMenu {
  .@{ant-prefix}-popover-content {
    margin-top: 14px;
  }
  .@{ant-prefix}-popover-arrow {
    top: 20px !important;
  }
  .@{ant-prefix}-popover-arrow,
  .@{ant-prefix}-tooltip-arrow {
    display: none;
  }
  & .@{ant-prefix}-popover-inner {
    @apply border-solid border-primary border-l-0 border-r-0 border-t-0 rounded-lg;

    background-color: var(--user-dropdown-button-bg);
    border-bottom-width: 5px;
  }
}

.user-info {
  display: flex;
  gap: 8px;
  align-items: center;
  max-width: 100%;
  padding: 0 8px;
}

.user-name {
  font-size: 14px;
  font-weight: 500;
}

.user-email {
  font-size: 12px;
  font-weight: 400;
}

.user-dropdown-action-item {
  &.sign-out {
    & > a {
      color: var(--secondary-red) !important;
    }
  }

  & > a {
    & > div {
      display: flex;
      gap: 4px;
      align-items: center;
    }

    display: flex;
    gap: 4px;
    align-items: center;
    padding: 0.5rem 0.375rem;
    color: var(--page-text-color) !important;
    border-radius: 0.375rem;

    &:hover {
      background-color: var(--dropdown-hover-bg);
    }
  }
}

.user-dropdown-popover {
  .@{ant-prefix}-popover-inner-content {
    overflow-x: hidden;
    overflow-y: auto;
  }

  .@{ant-prefix}-popover-inner {
    background-color: var(--nav-panel-bg);
  }

  & .ant-avatar-image {
    @apply rounded;
  }
}

// Used id as id has higher specificity than class
#modeRadioGroup {
  display: flex;
  justify-content: center;
  width: fit-content;
  margin: auto;
}
</style>
